import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.handlingLists.title',
    defaultMessage: 'Handling lists',
    description: 'title of the handling lists page',
  },
  secondaryActions: {
    switchLocations: {
      id: 'pages.handlingLists.secondaryActions.switchLocations',
      defaultMessage: 'Switch locations',
      description: 'Label of the switch locations action on the handling lists page',
    },
  },
  list: {
    item: {
      itemCount: {
        id: 'properties.items',
        defaultMessage: 'Items',
        description: 'label for the amount of items',
      },
      positions: {
        id: 'properties.positions',
        defaultMessage: 'Positions',
        description: 'label for the property positions',
      },
      location: {
        id: 'properties.location',
        defaultMessage: 'Location',
        description: 'label for the property location',
      },
      locationCount: {
        id: 'properties.locations',
        defaultMessage: 'Locations',
        description: 'label for the amount of locations',
      },
      shipmentCount: {
        id: 'properties.shipments',
        defaultMessage: 'Shipments',
        description: 'label for the amount of shipments',
      },
    },
  },
  confirmViewHandlingList: {
    title: {
      id: 'pages.handlingLists.confirmViewHandlingList.title',
      defaultMessage: 'Handling list already finished',
      description: 'label for the amount of items',
    },
    description: {
      id: 'pages.handlingLists.confirmViewHandlingList.description',
      defaultMessage:
        'This handling list has already been finished. You can view it or select a different one.',
      description: 'label for the amount of items',
    },
    actions: {
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'label of the close button',
      },
      view: {
        id: 'actions.view',
        defaultMessage: 'View',
        description: 'label of the view button',
      },
    },
  },
};

export default defineMessages(translations);
